const responseError = (res: any, row: any) => {
    const maxDisplayedCharacters = 100

    const body = res.response?.data
    // Older routes send the message as a plain string; newer ones send
    // `{ error }` (or `{ message }`). Show the text either way.
    const errorMessage =
        typeof body === 'string'
            ? body
            : body?.error || body?.message || res.message || ''

    if (errorMessage.length > maxDisplayedCharacters) {
        const truncatedMessage = `${errorMessage.substring(
            0,
            maxDisplayedCharacters
        )} ${'...'} `
        throw new Error(truncatedMessage)
    }

    throw new Error(errorMessage)
}

export default responseError
